/* eslint-disable import/prefer-default-export */

import { css } from 'styled-components';
import { Spacing24, Spacing40 } from 'autogen/design-tokens/tokens';
import { breakpoint, sizes } from 'variables';

const containerPadding = css`
    padding-left: ${Spacing24};
    padding-right: ${Spacing24};

    ${breakpoint.up(sizes.lg)} {
        padding-left: ${Spacing40};
        padding-right: ${Spacing40};
    }
`;

const containerMargin = css`
    margin-left: ${Spacing24};
    margin-right: ${Spacing24};

    ${breakpoint.up(sizes.lg)} {
        margin-left: ${Spacing40};
        margin-right: ${Spacing40};
    }
`;

const sliderPadding = css`
    scroll-padding-inline-start: ${Spacing24};
    scroll-padding-inline-end: ${Spacing24};

    ${breakpoint.up(sizes.lg)} {
        scroll-padding-inline-start: ${Spacing40};
        scroll-padding-inline-end: ${Spacing40};
    }
`;

export { containerPadding, containerMargin, sliderPadding };
